import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { activeUiLanguage } from '../lib/i18n';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../lib/api';

// Supabase handles the OAuth code-exchange automatically via detectSessionInUrl.
// This page just waits for the session to be set, then routes the user home.
export default function AuthCallback() {
  const { t, i18n } = useTranslation();
  const { session, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (session) api.setLanguage(activeUiLanguage()).catch(() => {}); // N-98
    navigate(session ? '/' : '/login', { replace: true });
  }, [session, loading, navigate, i18n.language]);

  return (
    <div className="min-h-screen flex items-center justify-center text-sm text-gray-500" data-testid="auth-callback">
      {t('authCallback.finishing')}
    </div>
  );
}
